module.exports = __webpack_public_path__ + "img/winerackdog41.70aada7f.jpg";